/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Access tier levels for users (matches PostgreSQL enum: \'basic\', \'pro\', \'enterprise\', \'institutional\')
 */
export enum AccessTier {

    Basic = 'basic',

    Pro = 'pro',

    Enterprise = 'enterprise',

    Institutional = 'institutional'
}
